import { useState, useEffect } from "react";
import axios from 'axios';

//constants
import { urlJsonTeams } from '../Constants';

const UseTeams = () => {

    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);
    const responseStatusOk = 200;

    useEffect(() => {
        const getTeams = async () => {
            const response = await axios(urlJsonTeams);
            
            if(response.status === responseStatusOk){
                setTeams(Object.values(response.data));
                setLoading(false);
            }            
        }           

        getTeams();                        
    },[]);

    return [loading, teams];
};

export { UseTeams };